import "./baseConfig/font.css.ts.vanilla.mjs";
import "./baseConfig/global.css.ts.vanilla.mjs";
import "./link.css.ts.vanilla.mjs";
var f = "p273__link-63f5_fc358f18c__16d67x81", p = "p273__link-63f5_fc358f18c__16d67x80";
export {
  f as animateStyle,
  p as linkStyle
};
//# sourceMappingURL=link.mjs.map
